import type { Annotation } from './AnnotationOverlay';

// UXV.V3 (#1418) — annotation list rendered alongside the screen preview. Each item shows the pin
// number (matching the numbered callout on the overlay), author, timestamp, the server-derived
// component_region (if any), and the comment text.

interface Props {
  annotations: Annotation[];
}

export default function AnnotationList({ annotations }: Props) {
  if (annotations.length === 0) {
    return (
      <div
        className="annotation-list annotation-list--empty"
        style={{ padding: 16, color: 'var(--text-secondary)', fontSize: 13 }}
      >
        No annotations yet — turn on Annotate and click the preview to add one.
      </div>
    );
  }

  return (
    <ul
      className="annotation-list"
      style={{ listStyle: 'none', margin: '12px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      {annotations.map((a, i) => (
        <li
          key={a.id}
          className="annotation-list__item"
          style={{ display: 'flex', gap: 10, padding: 12, border: '1px solid var(--border)', borderRadius: 8 }}
        >
          <span
            aria-hidden
            style={{
              flex: '0 0 auto', width: 22, height: 22, borderRadius: '50%',
              background: 'var(--primary, #7c3aed)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 12, fontWeight: 700,
            }}
          >
            {i + 1}
          </span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>
              <strong style={{ color: 'var(--text)' }}>{a.author}</strong>
              {' · '}
              {new Date(a.createdAt).toLocaleString()}
              {a.componentRegion ? <>{' · '}<span>{a.componentRegion}</span></> : null}
            </div>
            <div style={{ fontSize: 14, color: 'var(--text)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {a.comment}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
